import { ViewModel } from "../mvvm/ViewModel.js";
/**
 * Prefer a non-empty API list. Null, undefined, or empty keeps the static fallback
 * so the marketing site still shows work when the API is down or has no cards.
 */
export function featuredWorkOrFallback(api, fallback) {
    if (api && api.length > 0)
        return api;
    return fallback;
}
/**
 * FeaturedWorkViewModel loads public marketing cards for the Lumora landing page.
 */
export class FeaturedWorkViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ loading: false, error: null, items: null });
        this.client = client;
    }
    async load() {
        this.setState({ loading: true, error: null });
        try {
            const items = await this.client.listFeaturedWork();
            this.setState({ loading: false, error: null, items });
        }
        catch {
            this.setState({
                loading: false,
                error: "Could not load featured work.",
                items: null,
            });
        }
    }
}
//# sourceMappingURL=FeaturedWorkViewModel.js.map